import * as React from 'react';

const RevertIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" height="1em" width="1em" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2453 7.75999L14 10L14.0141 4L20 4.01405L17.6611 6.34743C19.1063 7.79481 20 9.79304 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 8.27232 6.54955 5.14012 10 4.25203V6.34141C7.66962 7.16508 6 9.38756 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 10.3445 17.3295 8.84557 16.2453 7.75999Z"
        fill="#3F3F3F"
      />
    </svg>
  );
};

export default RevertIcon;
